<ng-container>
  <div
    #banner
    class="relative rounded-t-3 *:rounded-t-3"
    [ngClass]="{
      'invisible size-0': !banner.hasChildNodes(),
      'visible h-48 w-full': banner.hasChildNodes(),
    }"
  >
    <ng-content select="[content=banner]"></ng-content>
  </div>
  <div
    class="flex items-center justify-between gap-xs px-md"
    [ngClass]="{
      'border-b border-grey-300 py-sm': !banner.hasChildNodes(),
      'border-0 pt-md': banner.hasChildNodes(),
    }"
  >
    <div class="flex w-full items-center">
      <div
        #icon
        class="flex items-center justify-center rounded-1 border border-grey-300 bg-grey-50"
        [ngClass]="{
          'invisible size-0 p-0': !icon.hasChildNodes(),
          'visible mr-xs size-[30px] p-xs': icon.hasChildNodes(),
        }"
      >
        <ng-content select="[content=icon]"></ng-content>
      </div>
      <h3 class="heading-base">{{ heading }}</h3>
    </div>
    <div class="w-20">
      <ng-content select="[content=logo]"></ng-content>
    </div>
  </div>
  <div class="p-md">
    <div class="space-y-md">
      @if (subHeading) {
        <div class="font-medium">{{ subHeading }}</div>
      }
      <ng-content select="[content=form]"></ng-content>
      <button class="btn w-full btn-vermilion" (click)="buttonClick()" cft-button [isLoading$]="isLoading$">
        {{ buttonText }}
      </button>
      <div class="text-center font-medium text-grey-500">
        <ng-content select="[content=foot-note]"></ng-content>
      </div>
    </div>
  </div>
</ng-container>
